import { useQuery } from '@apollo/client';
import { generateWhereQuery, generateQueryString } from '../queries';
const useGetImages = imageIds => {
  const queryName = 'getFiles';
  const action = generateWhereQuery(generateQueryString(queryName, queryName, 'id url data'));
  const {
    data = {},
    loading,
    error
  } = useQuery(action, {
    variables: {
      where: {
        id: {
          _in: imageIds
        }
      }
    },
    skip: !imageIds || !imageIds.length
  });
  return {
    data,
    loading,
    error
  };
};
export default useGetImages;
//# sourceMappingURL=use-get-images.js.map